import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { ScrollProgress } from "@/components/ScrollProgress";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import PartnersPage from "@/pages/PartnersPage";
import CareersPage from "@/pages/CareersPage";
import PqcProductPage from "@/pages/PqcProductPage";
import NotFound from "@/pages/NotFound";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <ScrollProgress />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/partners" element={<PartnersPage />} />
                    <Route path="/careers" element={<CareersPage />} />
                    <Route path="/products/pqc-readiness" element={<PqcProductPage />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </BrowserRouter>
            <Toaster theme="dark" position="top-right" richColors />
        </div>
    );
}

export default App;
